const serviceSuiteIconPath =
  'M96,132.1c0,0-23-18.3-45.4-36.1C33.1,110,15,124.3,15,124.3L92.4,187h7.2l77.4-62.7L141.4,96L96,132.1zM96,59.9L141.4,96L177,67.7L99.6,5h-7.2L15,67.7c0,0,18.1,14.4,35.6,28.3C73,78.2,96,59.9,96,59.9z'

export const ServiceSuiteIcon = ({ className, color, size }: { className?: string; color?: string; size: number }) => (
  <svg viewBox="0 0 192 192" width={size} height={size} vertical-align="middle" className={className}>
    <path fill={color ?? '#306CAD'} d={serviceSuiteIconPath} />
  </svg>
)
